import './index.scss';

import Tab from 'bootstrap/js/dist/tab';
import Collapse from 'bootstrap/js/dist/collapse';
import {flipbox} from 'modules/flipbox';
import {questionsForm} from 'modules/questionsForm';
import {aside} from 'modules/aside';

flipbox.bindEvents();
questionsForm.init();
aside.init();
